import { defineFcm } from '../shared/factory';

export const FCM_PETITION_TARGET_CONSOLIDATOR_RUN_CONSOLIDATION = defineFcm(
	'petition_target_consolidator_run_consolidation',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'petition-service',
		context: 'Petition target consolidation',
		description: 'Controls whether the PetitionTargetConsolidatorScaledJob runs consolidation in petition_service.',
		import: false,
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
